import React, { useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";

import LoadingSpinner from "shared/components/UIElements/LoadingSpinner";
import { useHttpClient } from "shared/hooks/http-hook";
import { StoreContext } from "shared/context/store-context";

import ThumbUp from "@mui/icons-material/ThumbUp";
import Grid from "@mui/material/Grid";
import CustomSelect from "shared/components/FormElements/Select";
import Button from "shared/components/FormElements/Button";
import { useForm } from "shared/hooks/form-hook";
import Accordion from "@mui/material/Accordion";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { VALIDATOR_REQUIRE } from "shared/util/validators";
import "./Admin.css";
import {
  getStudentsWithLocationProblems,
  getStudentsWithoutNotifications,
  getNotificationsWithoutParent,
  getPersonelWithLocationProblems,
} from "./utils";
import StudentsList from "features/users/student/StudentsList";
import { SCHOOL_TYPES } from "@routebot/constants";

const DataErrors = () => {
  const { t } = useTranslation();
  const store = useContext(StoreContext);
  const { isLoading, sendRequest } = useHttpClient();
  const [reportCreated, setReportCreated] = useState(false);

  const [studentsWithLocationProblems, setStudentsWithLocationProblems] = useState([]);
  const [studentsWithoutNotifications, setStudentsWithoutNotifications] = useState([]);
  const [personelWithLocationProblems, setPersonelWithLocationProblems] = useState([]);
  const [currentSchoolType, setCurrentSchoolType] = useState(null);

  const [formState, inputHandler] = useForm(
    {
      school: { value: "", isValid: false },
    },
    false
  );

  const createReport = async () => {
    const currentSchool = store.schools.find((s) => s.id === formState.inputs.school.value);
    setCurrentSchoolType(currentSchool?.type);

    // Reset states
    setStudentsWithLocationProblems([]);
    setStudentsWithoutNotifications([]);
    setPersonelWithLocationProblems([]);

    if (currentSchool?.type === SCHOOL_TYPES.SCHOOL) {
      let allActiveStudents = store.students
        .filter((s) => !s.hasOwnProperty("isActive") || s?.isActive)
        .sort((a, b) => (a.name > b.name ? 1 : -1));

      let allNotifications = store.relations;

      let activeStudentsInSchool = [...allActiveStudents];
      if (formState.inputs.school.value.toString() !== "619c62eb5d123200169418a8") {
        activeStudentsInSchool = allActiveStudents.filter(
          (s) => s.school.toString() === formState.inputs.school.value.toString()
        );
      }

      const problematicNotifications = getNotificationsWithoutParent(
        activeStudentsInSchool,
        store.users,
        allNotifications
      );
      if (problematicNotifications.length > 0) {
        problematicNotifications.forEach(async (n) => {
          try {
            await sendRequest(`${process.env.REACT_APP_BACKEND_URL}/relations/${n.id}`, "DELETE", null, {
              "Content-Type": "application/json",
            });
          } catch (err) {}
        });

        store.UpdateRelations();
        const problematicNotificationsIds = problematicNotifications.map((n) => n.id);
        allNotifications = allNotifications.filter((n) => !problematicNotificationsIds.includes(n.id));
      }

      setStudentsWithLocationProblems(getStudentsWithLocationProblems(activeStudentsInSchool));
      setStudentsWithoutNotifications(getStudentsWithoutNotifications(activeStudentsInSchool, allNotifications));
    } else if (currentSchool?.type === SCHOOL_TYPES.PERSONEL) {
      // Personel için sadece location kontrolü yapılır (userType === 10 olanlar)
      setPersonelWithLocationProblems(getPersonelWithLocationProblems(store.users, formState.inputs.school.value));
    }
    setReportCreated(true);
  };

  useEffect(() => {
    if (!formState.inputs.school.value) {
      setCurrentSchoolType(null);
      setReportCreated(false);
      setStudentsWithLocationProblems([]);
      setStudentsWithoutNotifications([]);
      setPersonelWithLocationProblems([]);
      return;
    }

    setReportCreated(false);
    setStudentsWithLocationProblems([]);
    setStudentsWithoutNotifications([]);
    setPersonelWithLocationProblems([]);
  }, [formState.inputs.school.value]);

  // if(isLoading || !store.vehicleRoutes) //HERE
  if (isLoading && false) {
    //HERE
    return (
      <div className="center">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <React.Fragment>
      <form>
        <Grid
          sx={{
            fontsize: 16,
            flexGrow: 1,
            display: "flex",
            flexDirection: { xs: "row", md: "row" },
            alignItems: "center",
            justifyContent: "flex-start",
            textAlign: "left",
            width: "100%",
            id: "report-receipts-container",
            padding: "10px",
          }}
          container
          spacing={1}
        >
          <Grid item xs={4}>
            <CustomSelect
              options={store.schoolOptions}
              id="school"
              onInput={inputHandler}
              label={t("dataErrors.institution")}
              errorText={t("dataErrors.selectInstitution")}
              initialValid={false}
              validators={[VALIDATOR_REQUIRE()]}
            ></CustomSelect>
          </Grid>

          <Grid item xs={3}>
            <div style={{ left: "10px", position: "relative", top: "8px" }}>
              <Button type="button" disabled={!formState.isValid} onClick={createReport}>
                {t("dataErrors.createReport")}
              </Button>
            </div>
          </Grid>

          {currentSchoolType === SCHOOL_TYPES.SCHOOL && (
            <Grid item xs={3}>
              <div style={{ left: "10px", position: "relative", top: "8px" }}>
                {t("dataErrors.onlyActiveStudents")}
                <br />
              </div>
            </Grid>
          )}
        </Grid>
      </form>
      {reportCreated && (
        <div>
          {/* <br /> */}
          <div className="adminpageContainer">
            <div className="adminListContainer" style={{ maxWidth: "800px", padding: "10px" }}>
              {/* SCHOOL tipi için öğrenci kontrolleri */}
              {currentSchoolType === SCHOOL_TYPES.SCHOOL && (
                <>
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      {studentsWithLocationProblems.length > 0 && (
                        <div>
                          {t("dataErrors.studentsWithoutLocation")} -{" "}
                          <strong>
                            {" "}
                            {studentsWithLocationProblems.length} {t("dataErrors.error")}{" "}
                          </strong>
                        </div>
                      )}

                      {studentsWithLocationProblems.length === 0 && (
                        <div style={{ display: "flex" }}>
                          <strong style={{ marginRight: "20px" }}>
                            {" "}
                            <ThumbUp />
                          </strong>{" "}
                          {t("dataErrors.allStudentsHaveLocation")}
                        </div>
                      )}
                    </AccordionSummary>
                    {studentsWithLocationProblems.length > 0 && (
                      <AccordionDetails display="flex">
                        {/* <StudentsList students={studentsWithLocationProblems} hideCreateNewItem={true} /> */}
                        {studentsWithLocationProblems.map((student, index) => (
                          <div key={index} style={{ width: "100%" }}>
                            {student.name}
                          </div>
                        ))}
                      </AccordionDetails>
                    )}
                  </Accordion>

                  <br />

                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      {studentsWithoutNotifications.length > 0 && (
                        <div>
                          {t("dataErrors.studentsWithoutNotifications")} -{" "}
                          <strong>
                            {" "}
                            {studentsWithoutNotifications.length} {t("dataErrors.error")}{" "}
                          </strong>
                        </div>
                      )}

                      {studentsWithoutNotifications.length === 0 && (
                        <div style={{ display: "flex" }}>
                          <strong style={{ marginRight: "20px" }}>
                            {" "}
                            <ThumbUp />
                          </strong>{" "}
                          {t("dataErrors.allStudentsHaveNotifications")}
                        </div>
                      )}
                    </AccordionSummary>
                    {studentsWithoutNotifications.length > 0 && (
                      <AccordionDetails display="flex">
                        {studentsWithoutNotifications.map((student, index) => (
                          <div key={index} style={{ width: "100%" }}>
                            {student.name}
                          </div>
                        ))}
                      </AccordionDetails>
                    )}
                  </Accordion>
                </>
              )}

              {/* PERSONEL tipi için personel konum kontrolü */}
              {currentSchoolType === SCHOOL_TYPES.PERSONEL && (
                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
                    {personelWithLocationProblems.length > 0 && (
                      <div>
                        {t("dataErrors.personelWithoutLocation")} -{" "}
                        <strong>
                          {" "}
                          {personelWithLocationProblems.length} {t("dataErrors.error")}{" "}
                        </strong>
                      </div>
                    )}

                    {personelWithLocationProblems.length === 0 && (
                      <div style={{ display: "flex" }}>
                        <strong style={{ marginRight: "20px" }}>
                          {" "}
                          <ThumbUp />
                        </strong>{" "}
                        {t("dataErrors.allPersonelHaveLocation")}
                      </div>
                    )}
                  </AccordionSummary>
                  {personelWithLocationProblems.length > 0 && (
                    <AccordionDetails display="flex">
                      {personelWithLocationProblems.map((personel, index) => (
                        <div key={index} style={{ width: "100%" }}>
                          {personel.name}
                        </div>
                      ))}
                    </AccordionDetails>
                  )}
                </Accordion>
              )}
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default DataErrors;
